/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { IEventBus } from "sirius-platform-support-library/shared/event-bus/event-bus.interface";
import { IAuthenticationService } from "sirius-platform-support-library/shared/authentication/authentication-service.interface";

export const ContactUsActionHandlerTypeName = "ContactUsActionHandler";

export class ContactUsActionHandler {
  private eventBus: IEventBus;
  private authenticationService: IAuthenticationService;
  private window: Window;
  private EventActionHandlerTypeName = "EventActionHandler";
  public static readonly CONTACT_US_ACTION_EVENT =
    "dell.tdm.navigation.contact.action";

  public constructor(
    eventBus: IEventBus,
    authenticationService: IAuthenticationService,
    window: Window
  ) {
    this.eventBus = eventBus;
    this.authenticationService = authenticationService;
    this.window = window;
  }

  public registerActionHandler() {
    this.register(
      this,
      ContactUsActionHandler.CONTACT_US_ACTION_EVENT,
      this.handleContactAction
    );
  }

  public register<T>(
    context: any,
    eventName: string,
    callback: (event: T | undefined) => void
  ) {
    this.eventBus.registerBroadcast<T>(
      this,
      this.EventActionHandlerTypeName,
      eventName,
      (event) => {
        callback.call(context, event?.data);
      }
    );
  }

  private handleContactAction() {
    if (
      this.authenticationService.isUserAuthenticated() &&
      this.isUserActiveAndInactive()
    ) {
      this.window.history.pushState(null, "", "/contact-us");
    } else {
      this.window.location.href = "https://www.dell.com/en-us/lp/contact-us";
    }
  }

  private isUserActiveAndInactive() {
    return (
      this.authenticationService
        .getUserContext()
        ?.claims["userStatus"]?.toString() == "ACTIVE" ||
      this.authenticationService
        .getUserContext()
        ?.claims["userStatus"]?.toString() == "INACTIVE"
    );
  }
}
